import additionalInfo from './en/additionalInfo';
import allDisputes from './en/allDisputes';
import button from './en/button';
import cancelDispute from './en/cancelDispute';
import caseStatusTags from './en/caseStatusTags';
import confirmationDisclaimer from './en/confirmationDisclaimer';
import contactFraud from './en/contactFraud';
import disputeDetails from './en/disputeDetails';
import disputeInfo from './en/disputeInfo';
import eligibility from './en/eligibility';
import faqsAnswers from './en/faqsAnswers';
import faqsQuestions from './en/faqQuestions';
import formError from './en/formError';
import questionnaire from './en/questionnaire';
import sandbox from './en/sandbox';
import sorter from './en/sorter';
import uploadDocuments from './en/uploadDocuments';
import transactionStatus from './en/transactionStatus';
import transactionDisputeStatusTitle from './en/transactionDisputeStatusTitle';
import transactionDisputeStatusDescription from './en/transactionDisputeStatusDescription';
var englishTranslations = {
    translation: {
        additionalContent: {
            placeholder: 'Dispute Amount'
        },
        additionalInfo: additionalInfo,
        allDisputes: allDisputes,
        button: button,
        calendar: {
            afterError: 'Please enter a date on or before {{formattedEndDate}}',
            beforeError: 'Please enter a date on or after {{formattedStartDate}}',
            dateBeyond180Days: 'Please select a date within the last 180 days. If the date is beyond that time period, please use our online chat for assistance opening your dispute.',
            greaterThanSevenDays: 'Must be greater than 7 business days from today',
            placeholder: 'Date (mm/dd/yyyy)',
            validDate: 'Please enter a valid date.',
            waitSevenDays: 'Please wait seven business days before disputing this transaction.'
        },
        cancelDispute: cancelDispute,
        cancelQuestionnaire: {
            description: 'Your progress will not be saved.',
            title: 'Closing will cancel the dispute. Do you wish to proceed?'
        },
        caseStatusTags: caseStatusTags,
        confirmation: {
            header: 'The dispute has been successfully submitted',
            redisputeHeader: 'We have all the details from your original dispute documented.',
            subHeader: 'Documentation can be sent to us through Manage Disputes. Please be sure to include any additional details you feel would help resolve your dispute.',
            redisputeSubHeaderOne: 'The supporting documents you submitted for the original dispute are listed below.',
            redisputeSubHeaderTwo: "You'll have the chance to submit any additional documents or comments in an upcoming step."
        },
        confirmationDisclaimer: confirmationDisclaimer,
        contactFraud: contactFraud,
        disputeDetails: disputeDetails,
        disputeInfo: disputeInfo,
        dropDown: {
            placeholder: 'Choose an Option'
        },
        eligibility: eligibility,
        cantIdentify: {
            title: 'We couldn’t identify the duplicate transaction on your account',
            description: 'If you need more help, please contact us using <0>Online Chat.</0>'
        },
        exit: {
            closeOut: 'Please click the button below or the "X" to close out this window.',
            description: 'We will not proceed with opening a dispute with Synchrony Bank at this time.',
            title: 'Thank you for your time'
        },
        faqs: {
            header: 'Frequently Asked Questions',
            link: 'Disputes FAQs',
            modalTitle: 'Disputes FAQs'
        },
        faqsAnswers: faqsAnswers,
        faqsQuestions: faqsQuestions,
        formError: formError,
        greeting: {
            afternoon: 'Good Afternoon',
            evening: 'Good Evening',
            morning: 'Good Morning'
        },
        label: {
            cancelDisputeModal: 'Synchrony Disputes Cancel Dispute Modal',
            headerRow: 'Dispute Case Header',
            questionnaireModal: 'Synchrony Disputes Questionnaire Modal'
        },
        lowBalanceDisputeCaseConfirmation: {
            contactUs: 'If you have any questions regarding this credit, please contact us via <0>Online Chat.</0>',
            description: "We have resolved your dispute and have issued you a credit for {{disputeAmount}}. All associated fees and interest associated with this charge will be waived. You'll see a credit on your account within the next 5 business days and can expect to see the adjustment on your statement within 1-2 billing cycles. A letter will also be sent to you.",
            title: 'Good News!'
        },
        modal: {
            title: 'Disputes'
        },
        questionnaire: questionnaire,
        recognizeTransaction: {
            question: 'Do you recognize the charge?',
            recognizeTransactionNo: 'No, I do not recognize the charge',
            recognizeTransactionYes: "Yes, I recognize the charge, but there's an issue",
            transaction: 'Tell us about this transaction'
        },
        review: {
            nextPage: 'On the next screen you will have the opportunity to send us documentation through our Online Chat link.',
            subTitle: 'YOUR DISPUTE REQUEST SUMMARY',
            title: "Let's review the details of your dispute",
            redisputeTitle: "Let's review your redispute details",
            lessTransactions: 'Less Transactions',
            moreTransactions: 'More Transactions'
        },
        sandbox: sandbox,
        sorter: sorter,
        technicalError: {
            apologize: 'We Apologize',
            authFailure: 'We are currently experiencing technical difficulties and are unable to initiate or view disputes.',
            callUs: 'We cannot continue with creating your dispute. Please try again later.',
            description: 'There was a technical error.',
            title: "We're Sorry",
            tryAgain: 'Please try again later.'
        },
        transactionStatus: transactionStatus,
        transactionDisputeStatusDescription: transactionDisputeStatusDescription,
        transactionDisputeStatusTitle: transactionDisputeStatusTitle,
        uploadDocuments: uploadDocuments
    }
};
export default englishTranslations;
//# sourceMappingURL=englishTranslations.js.map